module.exports = __webpack_public_path__ + "img/20_74.79ba0eed.png";